(function () {
  'use strict';

  function initBanner(bar) {
    if (bar.dataset.cdubInit) return;
    bar.dataset.cdubInit = 'true';

    // full-bleed width — cancel .drawer__inner's own side padding for just
    // this bar (measured, not hardcoded, and not touching the shared
    // ancestor itself so nothing else in the drawer is affected)
    var drawerInner = bar.closest('.drawer__inner');
    if (drawerInner) {
      var dcs = getComputedStyle(drawerInner);
      var padLeft = parseFloat(dcs.paddingLeft) || 0;
      var padRight = parseFloat(dcs.paddingRight) || 0;
      if (padLeft || padRight) {
        bar.style.marginLeft = '-' + padLeft + 'px';
        bar.style.marginRight = '-' + padRight + 'px';
        bar.style.width = 'calc(100% + ' + (padLeft + padRight) + 'px)';
      }
    }

    var cards = Array.prototype.slice.call(bar.querySelectorAll('[data-cdub-card]'));

    // carousel navigation
    var track = bar.querySelector('[data-cdub-track]');
    var prevBtn = bar.querySelector('[data-cdub-prev]');
    var nextBtn = bar.querySelector('[data-cdub-next]');
    var dotsWrap = bar.querySelector('[data-cdub-dots]');
    var dots = [];

    function buildDots() {
      if (!dotsWrap || !track) return;
      var visibleCards = cards.filter(function (c) { return c.style.display !== 'none'; });
      dotsWrap.innerHTML = '';
      dots = visibleCards.map(function (card, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'cdub__dot';
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        dot.addEventListener('click', function () {
          track.scrollTo({ left: card.offsetLeft, behavior: 'smooth' });
        });
        dotsWrap.appendChild(dot);
        return { el: dot, card: card };
      });
      updateDots();
    }

    function updateDots() {
      if (!dots.length || !track) return;
      var current = track.scrollLeft;
      var closest = 0;
      var closestDist = Infinity;
      dots.forEach(function (d, i) {
        var dist = Math.abs(d.card.offsetLeft - current);
        if (dist < closestDist) {
          closestDist = dist;
          closest = i;
        }
      });
      dots.forEach(function (d, i) {
        d.el.classList.toggle('cdub__dot--active', i === closest);
      });
    }

    function updateArrows() {
      if (!track || !prevBtn || !nextBtn) return;
      var visibleCount = cards.filter(function (c) { return c.style.display !== 'none'; }).length;
      var showNav = visibleCount > 1;
      prevBtn.style.display = showNav ? '' : 'none';
      nextBtn.style.display = showNav ? '' : 'none';
      if (dotsWrap) dotsWrap.style.display = showNav ? '' : 'none';
      prevBtn.disabled = track.scrollLeft <= 2;
      nextBtn.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
    }

    if (track && prevBtn && nextBtn) {
      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' });
      });
      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: track.clientWidth, behavior: 'smooth' });
      });
      track.addEventListener('scroll', updateArrows);
      track.addEventListener('scroll', updateDots);
      window.addEventListener('resize', updateArrows);
      updateArrows();
      buildDots();
    }

    // apply price colors directly (forceful !important — this theme's
    // cascade has repeatedly out-competed plain declarations elsewhere)
    bar.querySelectorAll('[data-cdub-price]').forEach(function (priceEl) {
      var bg = priceEl.dataset.bg;
      var color = priceEl.dataset.color;
      if (bg) priceEl.style.setProperty('background-color', bg, 'important');
      if (color) priceEl.style.setProperty('color', color, 'important');
    });

    function refreshVisibility() {
      if (!bar.isConnected) return;
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          bar.classList.toggle('cdub--cart-empty', cart.item_count === 0);
          if (cart.item_count === 0) {
            return;
          }
          cards.forEach(function (card) {
            var mode = card.dataset.visibilityMode;
            var productId = card.dataset.productId;
            var offerId = card.dataset.offerId;

            if (mode === 'hide_if_in_cart') {
              var inCartAny = cart.items.some(function (item) {
                return String(item.product_id) === productId;
              });
              card.style.display = inCartAny ? 'none' : '';
              return;
            }

            if (mode === 'hide_after_purchase') {
              var boughtAtOffer = cart.items.some(function (item) {
                return String(item.product_id) === productId &&
                  item.properties && item.properties['_upsell_offer_id'] === offerId;
              });
              card.style.display = boughtAtOffer ? 'none' : '';
              return;
            }

            if (mode === 'hide_if_subscribed') {
              var hasSubscription = cart.items.some(function (item) {
                return !!item.selling_plan_allocation;
              });
              card.style.display = hasSubscription ? 'none' : '';
              return;
            }

            // "always" — no cart-based hiding
            card.style.display = '';
          });
          updateArrows();
          buildDots();
        })
        .catch(function () {});
    }

    refreshVisibility();
    document.addEventListener('cart:updated', refreshVisibility);
    document.addEventListener('cart:refresh', refreshVisibility);

    setInterval(function () {
      if (!bar.isConnected) return;
      refreshVisibility();
    }, 2500);
  }

  // add-to-cart (delegated, works for any relocated instance)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cdub-add]');
    if (!btn) return;
    var variantId = btn.dataset.variantId;
    var offerId = btn.dataset.offerId || '';
    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding...';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1, properties: { _upsell_offer_id: offerId } }]
      })
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (err) { throw new Error(err.description || 'Add to cart failed'); });
        return fetch('?sections=cart-drawer,cart-icon-bubble');
      })
      .then(function (res) { return res.json(); })
      .then(function (sections) {
        var drawerHtml = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
        var newDrawer = drawerHtml.querySelector('cart-drawer');
        var oldDrawer = document.querySelector('cart-drawer');
        if (newDrawer && oldDrawer) {
          oldDrawer.innerHTML = newDrawer.innerHTML;
          oldDrawer.classList.remove('is-empty');
        }
        var bubbleWrap = document.getElementById('cart-icon-bubble');
        if (bubbleWrap && sections['cart-icon-bubble']) {
          var bubbleHtml = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
          var newBubble = bubbleHtml.body.firstElementChild;
          if (newBubble) bubbleWrap.innerHTML = newBubble.innerHTML;
        }
      })
      .catch(function (err) {
        console.error('Upsell banner add-to-cart error:', err);
        btn.disabled = false;
        btn.textContent = original;
      });
  });

  // ---- anchor relocation (same pattern as Scroll Bar / Progress Bar) ----

  var ANCHOR_SELECTOR = '[data-cd-upsell-anchor]';
  var savedClones = {};

  function getActiveAnchor() {
    var anchors = document.querySelectorAll(ANCHOR_SELECTOR);
    return anchors[0] || null;
  }

  function relocate() {
    var anchor = getActiveAnchor();

    if (!anchor) {
      document.querySelectorAll('.cdub').forEach(function (bar) {
        bar.style.display = 'none';
      });
      return;
    }

    var groups = {};
    document.querySelectorAll('.cdub').forEach(function (bar) {
      (groups[bar.id] = groups[bar.id] || []).push(bar);
    });

    Object.keys(groups).forEach(function (id) {
      var group = groups[id];
      var keeper = group[0];

      if (group.length > 1) {
        keeper = group.find(function (el) { return !anchor.contains(el); }) || group[group.length - 1];
        group.forEach(function (el) {
          if (el !== keeper) el.remove();
        });
      }

      if (keeper.dataset.enabled === 'false') {
        keeper.remove();
        delete savedClones[id];
        return;
      }

      savedClones[id] = keeper.cloneNode(true);
      delete savedClones[id].dataset.cdubInit;

      if (!anchor.contains(keeper)) {
        anchor.appendChild(keeper);
      }

      keeper.style.display = '';
      initBanner(keeper);
    });

    var current = Array.prototype.slice.call(anchor.children);
    var desired = current
      .slice()
      .sort(function (a, b) {
        return (parseInt(a.dataset.order, 10) || 0) - (parseInt(b.dataset.order, 10) || 0);
      });
    var alreadyInOrder = current.every(function (el, i) { return el === desired[i]; });
    if (!alreadyInOrder) {
      desired.forEach(function (child) {
        anchor.appendChild(child);
      });
    }
  }

  function restoreIfMissing() {
    var anchor = getActiveAnchor();
    if (!anchor) return;

    Object.keys(savedClones).forEach(function (id) {
      if (!document.getElementById(id)) {
        anchor.appendChild(savedClones[id].cloneNode(true));
        relocate();
      }
    });
  }

  function resync() {
    restoreIfMissing();
    relocate();
  }

  function bootstrap() {
    relocate();

    var anchor = getActiveAnchor();
    if (anchor) {
      var parent = anchor.closest('cart-drawer') || document.body;
      var observer = new MutationObserver(function () {
        restoreIfMissing();
      });
      observer.observe(parent, { childList: true, subtree: true });
    }

    setInterval(relocate, 2500);
  }

  document.addEventListener('shopify:section:load', relocate);
  document.addEventListener('shopify:section:reorder', relocate);
  document.addEventListener('shopify:block:select', relocate);

  document.addEventListener('cart:update', resync);
  document.addEventListener('cart:updated', resync);
  document.addEventListener('cart:refresh', resync);

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    bootstrap();
  } else {
    document.addEventListener('DOMContentLoaded', bootstrap);
  }
  document.addEventListener('prerenderingchange', bootstrap);
  window.addEventListener('pageshow', bootstrap);
})();